import { UscStoreService } from "../../../services/usc-store/usc-store.service";
import { DataTableAdapter } from "../../../adapters/datatable.adapter";
import { ViewColumnField } from '../../../models/view-config/view-column-field.model';

export class UscStoreHoursDataTableAdapter extends DataTableAdapter {

    uscStoreService: UscStoreService;
    store_team_ID: string;
    public current_store: any;
    public show_loading_icon: boolean = false;

    constructor(view: string, serviceCollection: any, store_team_ID: string) {
        super(view, serviceCollection);
        this.store_team_ID = store_team_ID;
        if (serviceCollection['uscStoreService']) this.uscStoreService = serviceCollection['uscStoreService'];
    }

    public initialize(): void {
        if (this.uscStoreService.isLeader()) {
            this.current_store = this.uscStoreService.getCurrentStoreVisitStore();
        }
        super.initialize();
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var params = { 'SP_STORE_USER_ID': this.current_store.store_user_ID, est: "ST_Search" };
        this.uscStoreService.getData(this.uscStoreService.view_store_hours_table, params).subscribe(
            result => {
                this.data_items = result.items;
                this.processDataItems(this.data_items, init_filter_fields);
                this.is_loading_data = false;
            },
            err => {
                console.log(err);
            }
        );
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        if (data_item && field) {
            if (data_item[field.key] == true) {
                fvc = { "background-color": "#00e000" };
            }
        }
        return fvc;
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            switch (field.key) {
                case 'sunday':
                case 'monday':
                case 'tuesday':
                case 'wednesday':
                case 'thursday':
                case 'friday':
                case 'saturday':
                    field_value = null;
                    break;
            }
            return field_value;
        }
        return null;
    }

    public isPagingEnabled(): boolean {
        return false;
    }

    public getNoDataMessage(): string {
        return "No Appointments Found";
    }

    public processAutoSave() {
        this.updateStoreHours();
    }

    updateStoreHours() {
        this.show_loading_icon = true;
        var data_items = JSON.parse(JSON.stringify(this.data_items));
        var params = { 'store_user_ID': this.current_store.store_user_ID };
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_store_hours_table, this.current_store.store_user_ID, this.uscStoreService.action_update_store_hours, data_items, params).subscribe(
            result => {
                this.sessionService.log("store hours updated");
                this.show_loading_icon = false;
            }
        )
    }

    public showLoadingIcon() { return this.show_loading_icon; }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling-setup/usc-store-hours-adapter.ts